module.exports = __webpack_public_path__ + "img/Gallery_1_11.9fbcbef6.jpeg";